const MOBILE_MARKER = '[BREAK_MOBILE]';
const DESKTOP_MARKER = '[BREAK_DESKTOP]';
const LINE_BREAK = '\n';
const SPACE = ' ';

const MOBILE_MARKER_REGEXP = /\[BREAK_MOBILE]/g;
const DESKTOP_MARKER_REGEXP = /\[BREAK_DESKTOP]/g;

export const hasLineBreakMarkers = (text: string): boolean =>
  text.includes(MOBILE_MARKER) || text.includes(DESKTOP_MARKER);

/**
 * Бэкенд помечает переносы строк для разных устройств:
 * - [BREAK_MOBILE] → `\n` на мобилке, на десктопе заменяется на пробел
 * - [BREAK_DESKTOP] → `\n` на десктопе, на мобилке заменяется на пробел
 * - [BREAK_MOBILE][BREAK_DESKTOP] / [BREAK_DESKTOP][BREAK_MOBILE] → `\n` на обоих устройствах
 */
export const normalizeTextLineBreaksByDevice = (text: string, isMobile: boolean): string => {
  if (!text) {
    return text;
  }

  const keepMarker = isMobile ? MOBILE_MARKER_REGEXP : DESKTOP_MARKER_REGEXP;
  const dropMarker = isMobile ? DESKTOP_MARKER_REGEXP : MOBILE_MARKER_REGEXP;

  return text.replace(keepMarker, LINE_BREAK).replace(dropMarker, SPACE);
};
